import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<div class=\"login loading\">\r\n</div>",{ moduleName: "login/templates/application-loading.hbs" })